import { createApp } from 'vue'
import App from './App.vue'
import router from './router';
import moment from 'moment';
import 'moment/locale/pt-br';
import Swal from 'sweetalert2';
import TheMask from 'vue-the-mask';
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import 'vuetify/styles'; // Importa os estilos do Vuetify
import '@mdi/font/css/materialdesignicons.css'; // Ícones
import { createHead } from '@vueuse/head';
import VueTheMask from 'vue-the-mask';
import VueJsCounter from 'vue-js-counter';
import SwiperCore, { Navigation, Pagination } from 'swiper/core';
SwiperCore.use([Navigation, Pagination]);
//import { Swiper as SwiperSlider, SwiperSlide } from 'swiper/vue';
import 'swiper/swiper-bundle.css';
import Viewer from 'v-viewer';
import 'viewerjs/dist/viewer.css';
import axios from 'axios';
//import { createGtm } from '@gtm-support/vue-gtm';

const vuetify = createVuetify({
  components,
  directives,
});

const app = createApp(App)
const head = createHead();
app.use(vuetify)
app.use(router)
app.use(TheMask)
app.use(head);
app.use(VueTheMask);
app.use(Viewer);
app.component('VueJsCounter', VueJsCounter);
// Registrar os componentes globalmente
//app.component('SwiperSlider', SwiperSlider);
//app.component('SwiperSlide', SwiperSlide);
/*app.use(
  createGtm({
    id: 'GTM-xxxx', // Your GTM single container ID, array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryParams: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}], // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
    defer: false, // Script can be set to defer to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded async by default
    compatibility: false, // Will add async and defer to the script tag to not block requests for old browsers that do not support async
    //nonce: '2726c7f26c', // Will add nonce to the script tag
    enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
    debug: true, // Whether or not display console logs debugs (optional)
    loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
    vueRouter: router, // Pass the router instance to automatically sync with router (optional)
    trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
  }),
);*/

app.config.globalProperties.$moment = moment

app.config.globalProperties.$imagens = 'https://garantemax.com.br/images/'
app.config.globalProperties.$imgURL = 'https://garantemax.com.br/imagensProducao/'
axios.defaults.baseURL = 'https://controle.garantemax.com.br/api'

app.config.globalProperties.$mensagemSucesso = function (mensagem) {
  Swal.fire(' ', mensagem, 'success')
}
app.config.globalProperties.$mensagemErro = function (mensagem) {
  Swal.fire(' ', mensagem, 'error')
}
app.config.globalProperties.$mensagemAviso = function (mensagem) {
  Swal.fire({
    position: 'center-center',
    icon: 'warning',
    title: mensagem,
    showConfirmButton: false,
    timer: 3000 // Tempo em milissegundos (3 segundos neste exemplo)
  })
}

app.config.globalProperties.$mensagemAvisoSucesso = function (mensagem) {
  Swal.fire({
    position: 'top-end',
    icon: 'success',
    title: mensagem,
    showConfirmButton: false,
    timer: 2000 // Tempo em milissegundos (3 segundos neste exemplo)
  })
}

app.config.globalProperties.$mensagemConfirma = function (mensagem) {
  return Swal.fire({
    icon: 'warning',
    title: mensagem,
    showCancelButton: true,
    confirmButtonText: 'Confirmar',
    cancelButtonText: 'Cancelar',
    reverseButtons: true
  });
};

// Criptografe os dados desejados
app.config.globalProperties.$axios = axios
axios.defaults.headers.common['Authorization'] = process.env.VUE_APP_AUTHORIZATION;
axios.interceptors.request.use((config) => {
  // Configurações adicionais antes de fazer a chamada à API
  return config;
});

axios.interceptors.response.use(
  (response) => {
    // Tratamento de sucesso da resposta da API
    return response;
  },
  error => {
    console.log(error);
    if (error.response && error.response.status === 401) {
      // Tratamento de erro para status 401 (Acesso não autorizado)
      app.config.globalProperties.$mensagemErro("Acesso não autorizado.");
    } else if (error.code === "ERR_NETWORK") {
      // Tratamento de erro para erro de rede
      app.config.globalProperties.$mensagemErro("Sistema fora do ar." + error);
    } else if (error.response && error.response.data && error.response.data.message) {
      // Tratamento de erro para outras respostas com mensagem
      app.config.globalProperties.$mensagemErro(error.response.data.message);
    } else {
      // Tratamento de erro genérico
      app.config.globalProperties.$mensagemErro("Falha ao conectar, contate o administrador.");
    }
    return Promise.reject(error);
  }
);

app.mount('#app')